import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-historico-proprietario',
  templateUrl: './consulta-historico-proprietario.component.html',
  styleUrls: ['./consulta-historico-proprietario.component.scss']
})
export class ConsultaHistoricoProprietarioComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {

  }

}
